
import './nav.less'
import React, { useState } from 'react'
import { createNativePAGE } from '@/api/materialCenter.js'
import { createAcc } from '@/api/nativePAGE.js'
import Mantle from '../Mantle/index.jsx'
import { message, Radio, Button } from 'antd'
console.log(React)

export default function SetPageNav(props) {
  const [ifon, setIfon] = useState({
    isMantle: false,
    value: 1,
    is: false
  })

  return (<div className='SetPageNav'>
    <div className='SetPageNav_left'>
      <button className='left_button' onClick={() => {
        props.myReturn && props.myReturn()
      }}>
        <i className='button_icon'>
          <svg width='18' height='18' viewBox='0 0 18 18' ><path d='M9.15411 4.75496C9.34899 4.56009 9.34943 4.24426 9.15509 4.04884L8.8051 3.6969C8.61007 3.50078 8.29286 3.50026 8.09719 3.69574L3.14601 8.64209C3.04692 8.74108 2.99805 8.87131 2.99942 9.0011C2.99806 9.1309 3.04692 9.26112 3.14601 9.36011L8.09719 14.3065C8.29286 14.5019 8.61007 14.5014 8.8051 14.3053L9.15509 13.9534C9.34943 13.7579 9.34899 13.4421 9.15411 13.2472L5.65688 9.75001H14.5C14.7761 9.75001 15 9.52615 15 9.25001V8.75001C15 8.47387 14.7761 8.25001 14.5 8.25001H5.65907L9.15411 4.75496Z' fill-rule='evenodd'></path></svg>
        </i>
      </button>

      <h3 className='left_title'>分享设置</h3>
    </div>
    <div className='SetPageNav_right'>
      <button className='right_button'
        onClick={() => {
          setIfon({
            ...ifon,
            isMantle: 'isItVisible'
          })
        }}
      ><span className='button_text'>完成并提交</span><i className='button_icon'><svg fill='currentColor' preserveAspectRatio='xMidYMid meet' height='1em' width='1em' viewBox='0 0 32 32' style={{ marginRight: '0px', marginLeft: '4px' }}><path d='M16 4l-2.5 2.5 8.117 7.667H4V17.5h17.617l-8.117 8L16 28l12-12.167'></path></svg></i></button>
    </div>

    { ifon.isMantle && <Mantle is={ifon.is}>

      { ifon.isMantle === 'isItVisible' && <div className='isItVisible'>
        <div className='isItVisible_main'>
          <Radio.Group onChange={(e) => {
            setIfon({
              ...ifon,
              value: e.target.value,
              is: !ifon.is
            })
          }} value={ifon.value}>
            <Radio value={1}>可见</Radio>
            <Radio value={2}>不可见</Radio>
          </Radio.Group>
        </div>

        <div className='isItVisible_button'>
          <Button style={{ margin: '0px 10px' }} onClick={() => {
            setIfon({
              ...ifon,
              isMantle: !ifon.isMantle
            })
          }}>取消</Button>
          <Button type='primary' style={{ margin: '0px 10px' }} onClick={() => {
            assemblyData(props, ifon, setIfon)
            setIfon({
              ...ifon,
              isMantle: 'waiting'
            })
          }}>确定</Button>
        </div>
      </div>}

      { ifon.isMantle === 'waiting' && <div className='waiting'>
        <img src='http://www.sucaijishi.com/uploadfile/2014/0524/20140524124233131.gif' />
        <span>创建中···</span>
      </div>}

    </Mantle> }
  </div>)
}

function assemblyComponentsData(components, props) {
  const data = []
  const data1 = []

  for (let i = 0; i < components.length; i++) {
    data.push({
      backgroundCover: '',
      backgroundColor: components[i].back,
      componentItemList: {
        componentItem: []
      }
    })
    for (let l = 0; l < components[i].comps.length; l++) {
      const item = components[i].comps[l]
      if (item.name === 'top_image_comp') {
        data[i].componentItemList.componentItem.push(comp_top_image_comp(item, data[i].componentItemList.componentItem))
      } else if (item.name === 'top_carousel_comp') {
        data[i].componentItemList.componentItem.push(comp_top_carousel_comp(item, data[i].componentItemList.componentItem))
      } else if (item.name === 'top_video_comp') {
        data[i].componentItemList.componentItem.push(comp_top_video_comp(item, data[i].componentItemList.componentItem))
      } else if (item.name === 'basics_image_comp') {
        data[i].componentItemList.componentItem.push(comp_basics_image_comp(item, data[i].componentItemList.componentItem))
      } else if (item.name === 'basics_text_comp') {
        data[i].componentItemList.componentItem.push(comp_basics_text_comp(item, data[i].componentItemList.componentItem))
      } else if (item.name === 'basics_OfficialAccount_comp') {
        data[i].componentItemList.componentItem.push(com_basics_OfficialAccount_comp(item, data[i].componentItemList.componentItem))
      } else if (item.name === 'marketing_suspension_comp') {
        data1.push({ ...comp_marketing_suspension_comp(item), myIndex: [i, l] })
      }
    }
  }

  const mainDate = {
    PageList: {
      Page: data
    },
    globalComponentItems: {
      componentItem: data1
    }
  }

  data1.length === 0 && delete mainDate.globalComponentItems

  return mainDate
}

function assemblySharingSettings(sharingSettings) {
  return {
    canvasName: sharingSettings.name,
    shareTitle: sharingSettings.title,
    shareDesc: sharingSettings.describe,
    shareThumbUrl: sharingSettings.thumbnail.path
  }
}

function comp_top_image_comp(item, cs) {
  let id = null
  let width = null
  let height = null
  let size = null
  let url = null
  if (item.ifon.ad_location === 'sns') {
    if (item.ifon.outer_style) {
      id = item.ifon.imgeIfon.sns.cardAdvertising.id
      size = item.ifon.imgeIfon.sns.cardAdvertising.size
      url = item.ifon.imgeIfon.sns.cardAdvertising.path
      width = 800
      height = 450
    } else {
      id = item.ifon.imgeIfon.sns.regularAdvertising.id
      size = item.ifon.imgeIfon.sns.regularAdvertising.size
      url = item.ifon.imgeIfon.sns.regularAdvertising.path
      width = 800
      height = 800
    }
  } else {
    id = item.ifon.imgeIfon.gzh.id
    size = item.ifon.imgeIfon.gzh.size
    url = item.ifon.imgeIfon.gzh.path
    width = 800
    height = 800
  }

  return {
    widgetTypeV2: 'topimg',
    widgetType: 'top',
    name: '顶部图片',
    type: '41',
    viewType: item.ifon.outer_style + '',
    adLocation: item.ifon.ad_location,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    paddingLeft: 0,
    id: `widget_${Math.ceil(Math.random() * 100000000)}_${cs.length + 1}`,
    initWidth: +width,
    initHeight: +height,
    imageHeight: +Math.ceil(height / 1.07),
    imageWidth: +Math.ceil(width / 1.07),
    top_image_source_id: id,
    fileSize: typeof (size) === 'object' ? 0 : size,
    imageMd5: '',
    materialId: id + '',
    pureImageUrl: url
  }
}

function comp_top_carousel_comp(item, cs) {
  const items = []
  for (let j = 0; j < item.ifon.image_id_list.length; j++) {
    const it = item.ifon.image_id_list[j]
    items.push({
      id: `slider_${Math.ceil(Math.random() * 10000000)}_${j + 1}`,
      componentItem: {
        type: '41',
        pureImageUrl: it.path,
        imageHeight: Math.ceil(it.height / 1.07),
        imageWidth: Math.ceil(it.width / 1.07),
        initHeight: it.height,
        initWidth: it.width,
        fileSize: it.size,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        materialId: it.id,
        imageMd5: ''
      }
    })
  }
  return {
    widgetType: 'top',
    widgetTypeV2: 'topslider',
    type: '101',
    name: '轮播图',
    activeIndex: 0,
    id: `widget_${Math.ceil(Math.random() * 100000000)}_${cs.length + 1}`,
    pageCtrType: '1',
    isFullScreen: '0',
    componentCount: `${items.length}`,
    componentGroupList: {
      componentGroup: items
    }

  }
}

function comp_top_video_comp(item) {
  let id = null
  let width = null
  let height = null
  if (item.ifon.ad_location === 'sns') {
    if (item.ifon.outer_style) {
      id = item.ifon.videoIfon.sns.cardAdvertising.id
      width = 640
      height = 360
    } else {
      id = item.ifon.videoIfon.sns.regularAdvertising.id
      width = 640
      height = 480
    }
  } else {
    id = item.ifon.videoIfon.gzh.id
    width = 750
    height = 1536
  }

  return {
    element_type: 'TOP_VIDEO',
    top_video_spec: {
      video_id: id,
      width,
      height,
      ad_location: item.ifon.ad_location,
      outer_style: item.ifon.outer_style,
      used_for_outer: item.ifon.used_for_outer
    }

  }
}

function comp_basics_image_comp(item) {
  return {
    element_type: 'IMAGE',
    image_spec: {
      image_id: item.ifon.imageIfon.id,
      width: 750,
      height: 750,
      padding_top: item.ifon.padding_top,
      padding_bottom: item.ifon.padding_bottom
    }

  }
}

function comp_basics_text_comp(item, cs) {
  return {
    widgetTypeV2: 'text',
    widgetType: 'text',
    type: '1',
    name: '文本',
    paddingTop: +item.ifon.padding_top,
    paddingBottom: +item.ifon.padding_bottom,
    paddingRight: 48,
    paddingLeft: 48,
    id: `widget_${Math.ceil(Math.random() * 100000000)}_${cs.length + 1}`,
    fontSize: item.ifon.font_size * 2 + '',
    fontColor: item.ifon.font_color,
    textAlignment: item.ifon.text_alignment + '',
    content: item.ifon.text,
    showType: item.ifon.font_style + '',
    expand: false,
    showAdvanced: false

  }
}

function comp_marketing_suspension_comp(item) {
  return {
    widgetTypeV2: 'floatbutton',
    widgetType: 'float_button',
    type: '134',
    name: '悬浮组件',
    wxad_styleType: `${item.ifon.style_type + 1}`,
    onlyShowInTimelineAd: '0',
    backgroundImg: '',
    backgroundColor: '#F0F0F0',
    backgroundColorAlpha: '0.96',
    backgroundBlurEffect: '1',
    backgroundBlurEffectColor: '#F0F0F0',
    backgroundBlurEffectColorAlpha: '0.5',
    titleColor: item.ifon.title_color,
    titleColorAlpha: '1',
    descColor: item.ifon.desc_color,
    descColorAlpha: '0.5',
    iconUrl: item.ifon.imageIfon.path,
    float_image_source_id: item.ifon.imageIfon.id,
    imageMd5: '',
    materialId: item.ifon.imageIfon.id,
    title: item.ifon.title,
    desc: item.ifon.desc,
    isFullClickable: '1',
    appearPaddingTop: '0',
    appearPaddingBottom: '0',
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    paddingLeft: 0,
    id: `widget_${Math.ceil(Math.random() * 10000000000)}`,
    componentItem: {
      widgetTypeV2: 'gh',
      widgetType: 'button',
      type: '21',
      name: '关注公众号',
      btnTitle: item.ifon.myType.officialAccount.title,
      subType: '17',
      fontSize: '28',
      fontColor: item.ifon.myType.officialAccount.font_color,
      btnType: '0',
      btnBgColorTheme: item.ifon.myType.officialAccount.bg_color,
      btnBorderColorTheme: '#FFFFFF',
      btnFontType: item.ifon.myType.officialAccount.text_alignment + '',
      btnStyle: item.ifon.myType.officialAccount.isFollow + '',
      cornerRadius: '4',
      useIcon: '0',
      field21_1: {
        'origBtnJumpUrl': '',
        'wxad_guide_group_id': ''
      },
      id: `widget_${Math.ceil(Math.random() * 10000000000)}`,
      layoutHeight: '70',
      layoutWidth: '160',
      borderSize: '0'
    }
  }
}

function com_basics_OfficialAccount_comp(item, cs) {
  return {
    widgetTypeV2: 'gh',
    widgetType: 'button',
    type: '21',
    name: '关注公众号',
    btnTitle: item.ifon.title,
    subType: item.ifon.isFollow ? '17' : '1',
    fontSize: '30',
    fontColor: item.ifon.font_color,
    btnType: '0',
    borderSize: '0',
    btnHeight: '80',
    btnBgColorTheme: item.ifon.bg_color,
    btnBorderColorTheme: item.ifon.border_color,
    btnFontType: item.ifon.text_alignment + '',
    btnStyle: '1',
    paddingTop: +item.ifon.padding_top,
    paddingBottom: +item.ifon.padding_bottom,
    paddingRight: 48,
    paddingLeft: 48,
    cornerRadius: 4,
    useIcon: item.ifon.isIcon ? '1' : '0',
    id: `widget_${Math.ceil(Math.random() * 100000000)}_${cs.length + 1}`
  }
}

function getNums(name, comps) {
  const s = []
  const acs = []
  for (let i = 0; i < comps.length; i++) {
    comps[i].name === name && s.push(comps[i])
    if ((comps[i].name === name) && comps[i].ifon.isFollow) {
      acs.push(comps[i])
    }
  }
  return {
    buts: s,
    acs
  }
}

function panDuanButs(butObj) {
  if (butObj.buts.length === 0 && butObj.acs.length === 0) {
    return '0'
  } else if (butObj.buts.length === butObj.acs.length) {
    return '131072'
  } else if (butObj.buts.length !== butObj.acs.length) {
    if (butObj.buts.length > 1) {
      return '131080'
    } else {
      return '8'
    }
  }
}

function assemblyData(props, ifon, setIfon) {
  const butObj = getNums('basics_OfficialAccount_comp', props.components[0].comps)
  const json = JSON.stringify({ adCanvasInfo: {
    ...assemblyComponentsData(props.components, props),
    ...assemblySharingSettings(props.sharingSettings),
    btnType: panDuanButs(butObj),
    canvasName: props.sharingSettings.name,
    sizeType: '1',
    basicWidth: '750',
    basicRootFontSize: '1',
    shareDesc: props.sharingSettings.describe,
    shareThumbUrl: props.sharingSettings.thumbnail.path,
    shareTitle: props.sharingSettings.title,
    pageID: '',
    shareWebUrl: '',
    top_type: '',
    fileSize: props.sharingSettings.thumbnail.size ? props.sharingSettings.thumbnail.size : '',
    supportInfo: {
      subType: ['17'],
      platform: [],
      iosAppid: [],
      appid: [],
      qid: ''
    },
    videoFileSize: 0,
    version: 'v2',
    original_page_id: 0,
    platform: 'native',
    wxad_copyFlag: '0',
    hasRedPkt: '0'
  }})

  establish({
    account_id: props.account_id,
    page_type: 4,
    share_title: props.sharingSettings.title,
    share_thumb_source_id: props.sharingSettings.thumbnail.id,
    share_thumb_url: props.sharingSettings.thumbnail.path,
    share_desc: props.sharingSettings.describe,
    canvas_name: props.sharingSettings.name,
    canvas_type: 7,
    canvas_info: json,
    common_page_id: props.sharingSettings.common_page_id,
    canvas_btn_type: panDuanButs(butObj),
    is_public: ifon.value
  }, ifon, setIfon, props)
}

async function establish(obj = {}, ifon, setIfon, props) {
  setIfon({
    ...ifon,
    isMantle: true
  })
  if (props.account_id) {
    createAcc(obj).then(() => {
      setIfon({
        ...ifon,
        isMantle: false
      })
      message.success('创建成功')
      props.account_id ? props.go_adq && props.go_adq(props.account_id) : props.go_public && props.go_public()
    }).catch(() => {
      setIfon({
        ...ifon,
        isMantle: false
      })
    })
  } else {
    delete obj.common_page_id
    createNativePAGE(obj).then(() => {
      setIfon({
        ...ifon,
        isMantle: false
      })
      message.success('创建成功')
      props.account_id ? props.go_adq && props.go_adq(props.account_id) : props.go_public && props.go_public()
    }).catch(() => {
      setIfon({
        ...ifon,
        isMantle: false
      })
    })
  }
}

